import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AssinanteEtiqueta, ReportEtiquetaProfissionalRequest, ReportEtiquetaProfissionalResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './etiqueta-profissional.model';

/** Cliente HTTP do assistente assíncrono Etiqueta Profissional (Médico). */
@Injectable({ providedIn: 'root' })
export class EtiquetaProfissionalService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.etiquetaProfissional;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista os assinantes vigentes do órgão da UF (QryAssinantes do legado). */
    listarAssinantes(uf: string): Observable<AssinanteEtiqueta[]> {
        return this.http.get<AssinanteEtiqueta[]>(`${this.PATH}/assinantes`, { params: { uf } });
    }

    exportarPdf(request: ReportEtiquetaProfissionalRequest): Observable<HttpResponse<ReportEtiquetaProfissionalResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportEtiquetaProfissionalResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportEtiquetaProfissionalRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
